import {inject, Injectable} from '@angular/core';
import {ProductCardFilesApiService} from "../../../../services-api/product-card-files-api.service";
import {RecordTableApiService} from "../../../../../../../core/services-api/record-table-api.service";
import {
  AttachProductCardFileParams,
  DeleteFileParams,
  GetFilesParams
} from "../../../../types/product-card-files.types";
import {RecordUpdateRequestParams} from "../../../../../../../core/types/records-table.types";
import {ListingFileData} from "../types/listing-file-data.types";

@Injectable({
  providedIn: 'root'
})
export class ListingFilesModalService {
  private productCardFilesApiService: ProductCardFilesApiService = inject(ProductCardFilesApiService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);

  public getFiles(getFilesParams: GetFilesParams): Promise<Array<ListingFileData>> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.fetchFiles<ListingFileData>(getFilesParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public attachFile<T>(attachProductCardFileParams: AttachProductCardFileParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.attachFile<T>(attachProductCardFileParams).subscribe({
        next: (data: T) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public deleteFile(deleteFileParams: DeleteFileParams): Promise<void> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.deleteFile(deleteFileParams).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public updatedRecordField<T>(recordUpdateRequestParams: RecordUpdateRequestParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.updateRecord<T>(recordUpdateRequestParams).subscribe({
        next: (recordData: T) => resolve(recordData),
        error: (error) => reject(error)
      });
    });
  }
}
